export const getModifiedResponse = (response, keyName) => {
  if (response && response.data && keyName && response.data[keyName]) {
    return response.data[keyName].map((item) => ({
      label: item.name === "Type" ? "Door" : item.name,
      value: item.value,
    }));
  } else if (response && response.data && !keyName) {
    return response.data.map((item) => ({
      label: item.name,
      value: item.value,
    }));
  } else {
    return [];
  }
};
